export default "__VITE_ASSET__f60f372a__"